<template>
  <div v-if="loading" class="d-flex justify-center align-center" style="width: 100%;min-height: 20vh;">
    <fulfilling-bouncing-circle-spinner
        :animation-duration="4000"
        :size="90"
        color="#07D1BF"
      />
  </div>
</template>

<script>
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'

export default {
  name: 'template-full-loading',
  components: {
    FulfillingBouncingCircleSpinner
  },
  props: {
    loading: Boolean
  }
}
</script>
